export default __webpack_public_path__ + "static/media/flag-uk.3af40212.svg";